import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {Oppgavesskjemamodell, OppgavesskjemTilleggsdata, OppgaveTjenesteWeb} from "../../OppgaveTjenesteWeb";
import {MdDialogController} from "../../../../tjenester/Dialog";

const css = require('./redigerOppgaveDialog.scss');

export function registrerRedigerOppgaveDialog(angular: IModule) {
    angular
        .service(RedigerOppgaveDialog.regNavn, RedigerOppgaveDialog.forInjisering())
        .controller(RedigerOppgaveDialogKontroller.regNavn, RedigerOppgaveDialogKontroller.forInjisering());
}

export class RedigerOppgaveDialog {
    static regNavn = "wm.oppgave.modale.redigerOppgaveDialog.RedigerOppgaveDialog";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            RedigerOppgaveDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./redigerOppgaveDialog.html'),
        controller: RedigerOppgaveDialogKontroller.regNavn,
        controllerAs: 'ktr',
        bindToController: true
    };

    visRedigerOppgaveDialog(oppgave: l.OppgaveModell) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {oppgave: oppgave}}));
    }

    visNySaksoppgaveDialog(sak: l.AgendaelementModell) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {sak: sak}}));
    }

    visNyBeslutningsoppgaveDialog(beslutning: l.BeslutningModell) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {beslutning: beslutning}}));
    }

    visNyFrittståendeOppgaveDialog() {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {frittstående: true}}));
    }
}

export class RedigerOppgaveDialogKontroller implements MdDialogController {
    static regNavn = "wm.oppgave.modale.redigerOppgaveDialog.RedigerOppgaveDialogKontroller";

    static forInjisering() {
        return [
            OppgaveTjenesteWeb.regNavn,
            GruppeRessurs.regNavn,
            regNavn.md.$mdDialog,
            RedigerOppgaveDialogKontroller
        ]
    }


    constructor(private oppgaveTjenesteWeb: OppgaveTjenesteWeb,
                private gruppeRes: GruppeRessurs,
                private $mdDialog: angular.material.IDialogService) {
    }

    $onInit(){
        this.initData();
    }

    oppgave: l.OppgaveModell; //satt via locals.oppgave i dialogKonfigurasjon
    sak: l.AgendaelementModell; //satt via locals.sak i dialogKonfigurasjon
    beslutning: l.BeslutningModell; //satt via locals.beslutning i dialogKonfigurasjon
    frittstående: boolean; //satt via locals.frittstående i dialogKonfigurasjon

    oppgavesskjemTilleggsdata: OppgavesskjemTilleggsdata;
    oppgaveskjemamodell: Oppgavesskjemamodell;

    tilgjengeligeGrupper: l.GruppeModell[]; //kun relevant ved opprettelse av frittstående oppgave
    gruppe: l.GruppeModell; //kun relevant ved opprettelse av frittstående oppgave

    modus: string;
    lagrer = false;
    idag = new Date();

    gruppeEndret() {
        this.oppgavesskjemTilleggsdata = this.oppgaveTjenesteWeb.initOppgaveSkjemaTilleggsdata(this.gruppe.id);
        this.oppgaveskjemamodell.ansvarlig = null;
    }

    lagre(skjema) {
        if (!skjema.$valid) return;
        (this.modus == "rediger" ?
            this.oppgaveTjenesteWeb.oppdaterOppgave(this.oppgaveskjemamodell) :
            this.oppgaveTjenesteWeb.opprettOppgave(this.oppgaveskjemamodell))
            .then(oppgave => this.lukkDialog())
            .finally(() => this.lagrer = false);

    }

    avbryt() {
        this.lukkDialog();
    }

    //hjelpemetoder

    private initData() {
        if (this.sak) {
            this.oppgaveskjemamodell = this.oppgaveTjenesteWeb.initNySaksoppgaveSkjemaModell(this.sak);
            this.oppgavesskjemTilleggsdata = this.oppgaveTjenesteWeb.initOppgaveSkjemaTilleggsdata(this.sak.eiendeGruppeId);
            this.modus = "nySaksoppgave";
            return;
        }

        if (this.beslutning) {
            this.oppgaveskjemamodell = this.oppgaveTjenesteWeb.initNyBeslutningsoppgaveSkjemaModell(this.beslutning);
            this.oppgavesskjemTilleggsdata = this.oppgaveTjenesteWeb.initOppgaveSkjemaTilleggsdata(this.beslutning.eiendeGruppeId);
            this.modus = "nyBeslutningsoppgave";
            return;
        }

        if (this.frittstående) {
            this.tilgjengeligeGrupper = this.gruppeRes.finnTilgjengeligeGrupper();
            this.tilgjengeligeGrupper.$promise.then(grupper => {
                this.oppgaveskjemamodell = this.oppgaveTjenesteWeb.initNyFrittståendeOppgaveSkjemaModell();
                this.gruppe = grupper[0];
                this.oppgavesskjemTilleggsdata = this.oppgaveTjenesteWeb.initOppgaveSkjemaTilleggsdata(grupper[0].id);
            });
            this.modus = "nyFrittståendeOppgave";
            return;
        }

        this.oppgavesskjemTilleggsdata = this.oppgaveTjenesteWeb.initOppgaveSkjemaTilleggsdata(this.oppgave.eiendeGruppeId);
        this.oppgaveskjemamodell = this.oppgaveTjenesteWeb.initRedigerOppgaveSkjemaModell(this.oppgave);
        this.modus = "rediger";
    }

    private lukkDialog() {
        this.$mdDialog.hide();
    }
}
